var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"sk-double-bounce"},[_c('div',{staticClass:"sk-child sk-double-bounce1"}),_c('div',{staticClass:"sk-child sk-double-bounce2"})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }